/** @jsxImportSource @emotion/react */
import Panels from 'src/components/Panel/Panels';

import ContractsListPanel from './ContractsListPanel';

export default function Contract() {
  return <Panels main={ContractsListPanel} />;
}
